import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	preventPushDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.prevent-push-description-non-final',
		defaultMessage:
			'To receive all your notifications from the Jira Cloud mobile app instead of Opsgenie, you can turn off the Opsgenie mobile app in your contact methods.',
		description: 'Description of preventing push notifications card',
	},
	ogTurnedOffNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.og-turned-off-non-final',
		defaultMessage:
			"Turned off. You'll no longer get push notifications from the Opsgenie mobile app.",
		description: 'Opsgenie turned off message',
	},
	contactMethodDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.contact-method-description-non-final',
		defaultMessage:
			"Check and update any missing contact methods, so that you get all the alert notifications as configured in the central notification template that's applied to you.",
		description: 'Description of keeping contact methods up to date',
	},
	manageContactMethodsNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.manage-contact-methods-non-final',
		defaultMessage: 'Manage contact methods',
		description: 'Manage contact methods button of keeping contact methods up to date card',
	},
	deleteOgCantactMethodsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.delete-og-cantact-methods-description-non-final',
		defaultMessage: `To ensure your notifications aren't pushed to your Opsgenie mobile app (which is now turned off), delete your Opsgenie contact method.

This makes Jira Mobile Cloud mobile app your primary contact method in central-notification templates.`,
		description: 'Description of deleting Opsgenie contact methods card',
	},
	turnOffOgCtaNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.turn-off-og-cta-non-final',
		defaultMessage: 'Turn off Opsgenie mobile app contact method',
		description:
			'Turn off Opsgenie mobile app contact method button text of deleting Opsgenie contact methods card',
	},
	acknowledgeTurnOffOgNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.acknowledge-turn-off-og-non-final',
		defaultMessage: "I understand I'll stop getting alert notifications from Opsgenie mobile app",
		description:
			'Acknowledge turn off Opsgenie label for the checkbox of deleting Opsgenie contact methods card',
	},
	avoidDuplicateNotificationsNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-two.avoid-duplicate-notifications-non-final',
		defaultMessage:
			'To avoid duplicate notifications from Jira and Opsgenie mobile apps, you can turn off the Opsgenie mobile app in your contact methods. This will only turn off your Opsgenie mobile app as a contact method, so your notification rules and preferences will not be affected.',
		description: 'Main message of prevent duplicate notifications card',
	},
});
